function cov_24gw0wugli() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Search.tsx";
  var hash = "f04cf378461ed0a24ded6ccb5069433e7dfe4d08";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Search.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 46
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f04cf378461ed0a24ded6ccb5069433e7dfe4d08"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_24gw0wugli = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_24gw0wugli();
var Icon = (cov_24gw0wugli().s[0]++, {
  name: 'search',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.5682 16.5683C13.273 17.4708 11.6983 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 11.8177 17.3938 13.4937 16.3726 14.8371L21.7678 20.2323C22.2559 20.7205 22.2559 21.5119 21.7678 22.0001C21.2796 22.4883 20.4882 22.4883 20 22.0001L14.5682 16.5683ZM15.5 10C15.5 13.0376 13.0376 15.5 10 15.5C6.96243 15.5 4.5 13.0376 4.5 10C4.5 6.96243 6.96243 4.5 10 4.5C13.0376 4.5 15.5 6.96243 15.5 10Z\" fill=\"currentColor\"/>"
});
export default Icon;